import React from "react";



// The ...props means, spread all of the passed props onto this element
// That way we don't have to define them all individually
function Rating({ stars }) {
  const whole = Math.floor(stars);
  const wholeStars = [1,2,3,4,5].slice(0, whole);
  const halfStar = stars - whole;
  return  <div>
      {
        wholeStars.map( (_, i) =>
                  <span key={i} className="star">
                    <i className="bi bi-star-fill"></i>
                  </span>
                )
              }
      <span className="star">{halfStar ? <i className="bi bi-star-half"></i> : null}</span>
      &nbsp;<span>{stars}</span>
    </div>;
}

export default Rating;
